import { ToastContainer } from "react-toastify";
import Footer from "../../../components/footer";
import "./style.css";
import { useContext, useEffect, useMemo, useState } from "react";
import Notification from "../../../components/toast";
import { ListFilter } from "../../../components/list-filter";
import { ModalFilterSupplier } from "../../../components/register/register-fornecedor/filter";
import { ContextRegisterSupplier } from "../../../components/register/register-fornecedor/context";
import { ModalRegisterSupplier } from "../../../components/register/register-fornecedor/modal-register";
import TableSupplier from "../../../components/register/register-fornecedor/table";
import HeaderReport from "../../../components/header/report";
import ModalMain from "../../../components/modal";
import ReportModalContent from "../../../components/report/ReportModalContent";

// Os relatórios genéricos (ReportModalContent/generateReport) esperam filtros no formato { chave: { label, value } }
const PARAM_LABELS = {
	nomefantasia: "Nome Fantasia",
	razaosocial: "Razao Social",
	cidade: "Cidade",
};

export const MainRegisterFornecedor = ({ isSelector = false, onSelectSupplier }) => {
	const options = {
		title: "Cadastro de Fornecedor",
		subTitle: "Fornecedor",
		identReport: `reportFornecedor`, //usado para definir os event listners
		reportColumns: [
			// Identificação principal
			{ key: "nome", label: "Nome", align: "left", visible: true },
			{ key: "fantasia", label: "Fantasia", align: "left", visible: true },

			// Contato
			{ key: "telefone_1", label: "Telefone 1", align: "center", visible: true },
			{ key: "telefone_2", label: "Telefone 2", align: "center", visible: false },
			{ key: "telefone_3", label: "Telefone 3", align: "center", visible: false },
			{ key: "email", label: "Email", align: "left", visible: true },

			// Localização
			{ key: "nomecidade", label: "Cidade", align: "left", visible: true },
			{ key: "uf", label: "UF", align: "center", visible: true },
			{ key: "rua", label: "Rua", align: "left", visible: false },
			{ key: "numero", label: "Número", align: "center", visible: false },
			{ key: "bairro", label: "Bairro", align: "left", visible: false },
			{ key: "cep", label: "CEP", align: "center", visible: false },
			{ key: "complemento", label: "Complemento", align: "left", visible: false },

			// Status e datas
			{ key: "ativo", label: "Status", align: "center", format: "badgePgto", visible: true },
			{ key: "data_cadastro", label: "Data Cadastro", align: "left", format: "datetime", visible: true },
			{
				key: "data_movimentacao",
				label: "Última Movimentação",
				align: "left",
				format: "datetime",
				visible: false,
			},

			// Pessoa física/jurídica
			{ key: "pessoa_fisica", label: "Pessoa Física", align: "center", visible: false },

			// Documentos (ocultos por padrão)
			{ key: "cpf", label: "CPF", align: "center", visible: false },
			{ key: "rg", label: "RG", align: "center", visible: false },

			// Observação
			{ key: "obs", label: "Observação", align: "left", visible: false },
		],
	};

	const { openModalFilterSupplier, openModalRegisterSupplier, filterData, fetchAllSuppliers } =
		useContext(ContextRegisterSupplier);

	const [reportData, setReportData] = useState([]);
	const [isLoadingReport, setIsLoadingReport] = useState(false);

	useEffect(() => {
		if (isSelector) {
			openModalFilterSupplier();
		}
	}, []);

	const open = () => {
		openModalFilterSupplier();
	};

	const handleOpenModalReport = async () => {
		try {
			setIsLoadingReport(true);
			const data = await fetchAllSuppliers();
			setReportData(data);

			const event = new CustomEvent(`${options.identReport}`);
			window.dispatchEvent(event);
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setIsLoadingReport(false);
		}
	};

	const reportFilters = useMemo(() => {
		if (!filterData || typeof filterData !== "object") return {};

		const filters = {};

		if (filterData.param) {
			filters.param = {
				label: PARAM_LABELS[filterData.param] || "Parâmetro",
				value: filterData.paramValue || "",
			};
		}

		if (filterData.ativo) {
			filters.ativo = {
				label: "Ativo",
				value: filterData.ativo,
			};
		}

		return filters;
	}, [filterData]);

	return (
		<div className="container-register">
			<header className="mt-page">
				<div className="grid grid-cols-2">
					<div className="col-span-1">
						<HeaderReport title={options.title} subTitle={options.subTitle} />
					</div>
					<div className="col-span-1 flex justify-end">
						<ListFilter filterData={filterData} />
					</div>
				</div>
				<ModalFilterSupplier />
				<ModalRegisterSupplier />
				<ToastContainer />
				<div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
					<button
						className="min-w-40 btn btn-sm btn-success w-15"
						onClick={(e) => openModalRegisterSupplier()}
					>
						{options.title}
					</button>
					<div className="flex gap-2 flex-wrap ">
						<button className="min-w-40 btn btn-sm btn-primary w-25" onClick={(e) => open(e)}>
							Listar
						</button>
						{options.reportColumns && (
							<button
								className="min-w-40 btn btn-sm btn-danger"
								onClick={handleOpenModalReport}
								disabled={isLoadingReport}
							>
								{isLoadingReport ? "Carregando..." : "Relatório"}
							</button>
						)}
					</div>
				</div>

				{/* <div className="d-flex align-items-center justify-content-between">
					<button className="btn btn-sm btn-success w-15" onClick={(e) => openModalRegisterSupplier()}>
						Cadastrar Fornecedor
					</button>

					<button className="btn btn-sm btn-primary w-25" onClick={(e) => open()}>
						Listar
					</button>
				</div> */}
			</header>
			<main>{<TableSupplier isSelector={isSelector} onSelectSupplier={onSelectSupplier} />}</main>
			<footer>
				<Footer />
			</footer>
			<ModalMain ident={options.identReport}>
				<ReportModalContent
					reportColumns={options.reportColumns}
					data={reportData}
					filters={reportFilters}
					title={options.title}
					headerSubtitle={options.subTitle}
					defaultFormat="pdf" // ou "csv"
				/>
			</ModalMain>
		</div>
	);
};
